import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=221d7099"
import script from "./ModalLayout.vue?vue&type=script&lang=js"
export * from "./ModalLayout.vue?vue&type=script&lang=js"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=221d7099&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports